import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Company} from "../../dto/company";
import {ReferralsService} from "../services/referrals.service";
import {CompanyService} from "../services/company.service";
import {RoleService} from "../../services/role.service";
import {ReferralStatus} from "../../dto/ident-status";
import {FormControl} from "@angular/forms";
import {MatTableGeneratorComponent} from "../../shared/mat-table-generator/mat-table-generator.component";
import {MatButtonToggle} from "@angular/material/button-toggle";
import {MultiCrudDataSource} from "../../table-datasouces/multi-crud.datasource";
import {toDateString} from "../../providers/app-date-adapter";
import {ContentRowField} from "../../shared/content-row/content-row.component";
import {GiftCard, Referral} from "../../dto/order";
import {GiftCardsService} from "../../services/gift-cards.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-giftcards',
  templateUrl: './gift-cards.component.html',
  styleUrls: ['./gift-cards.component.css']
})
export class GiftCardsComponent implements OnDestroy, AfterViewInit, OnInit {
  isLoading = false;
  companies: Company[] = [];

  public dateFiltersList = [
    { name: 'creation', header: 'Creation' },
  ];


  constructor(
    private giftCardService: GiftCardsService,
    private companyService: CompanyService,
    private roleService: RoleService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  public referralStatus = ReferralStatus;
  public referralSpecialStatusSelect = new FormControl();
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;
  @ViewChild(MatButtonToggle, { static: false }) allButton: MatButtonToggle;

  dataSource = new MultiCrudDataSource(this.giftCardService);

  columns = [
    { columnDef: 'creationDate', header: 'Creation date', cell: row => `${toDateString(row.creationDate) || ''}` },
    { columnDef: 'customer', header: 'Customer', cell: row => `${row.customer.firstName} ${row.customer.lastName}` },
    { columnDef: 'phoneNumber', header: 'Phone', cell: row => `${row.customer.phone}` } ,
    { columnDef: 'Brand', header: 'Phone', cell: row => `${row.brand.name}` } ,
    { columnDef: 'Amount', header: 'Amount', cell: row => `${row.faceValue} ${row.faceCurrency}` } ,
    { columnDef: 'PurchasePrice', header: 'Purchase Price', cell: row => `${row.purchasePrice} EUR` } ,
    { columnDef: 'AmountPaid', header: 'Amount Paid', cell: row => `${row.amountPaid} EUR` } ,
    { columnDef: 'isPaid', header: 'Paid', cell: row => row.isPaid ? 'YES':'NO' } ,


  ] as ContentRowField<GiftCard>[];

  checkAllButton() {
    try {
      this.allButton.checked = true;


    } catch (e) {
      console.log(e);
    }
  }

  getViewLink = (item: GiftCard): string => 'detail/' + item.id.toString();

  getEditLink = (item: GiftCard): string => item.id.toString() + '/edit';
  public dialogRemoveText = 'Removing gift cards';


  ngOnInit(): void {

  }

  clearFilter() {
    this.table.clearFilter();
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  editEnabled() {
    return false; // this.roleService.hasRoles("admin");
  }

  deleteEnabled() {
    return false; // this.roleService.hasRoles("admin");
  }

  multiselectEnabled() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner']);
  }

  currentUserIsAdmin(){
    return this.roleService.hasRoles('admin');
  }

  triggerSearch() {
    this.onSearch();
  }
  onSearch(ignore: boolean = false) {
    if ( this.isLoading ) {
      return;
    }
    if (ignore) {
      return;
    }
    this.table.applyFilter();
  }
  ngAfterViewInit(): void {

    this.companyService.getAll().subscribe(result => {
      this.companies = result.data;
    });
    if (this.currentUserIsAdmin()) {

    }

  }

  ngOnDestroy(): void {
  }

  goToBrands() {
    this.router.navigate(['brands'], {relativeTo: this.route}).then();
    return false;
  }
}
